// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"News_newsItem__39KlO","title":"News_title__316PU","wrapper":"News_wrapper__1rmoF","paragraph":"News_paragraph__1MqHf","date":"News_date__3gd5a"};